<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  computed: {
    key() {
      return this.$route.fullPath;
    }
  }
};
</script>
<style lang="less">
html,
body,
#app {
  width: 100%;
  height: 100%;
}
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
}
</style>
